import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { styled, Theme } from '@mui/material/styles';
import { InputLabel, GlobalStyles, Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';


export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  flexGrow: 1,
  fontSize: '0.875rem',
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  letterSpacing: '0.01em',
  marginBottom: 1
}));

export const StyledSectionHeader = styled(Typography)(({ theme }) => ({
  fontSize: '0.8rem',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  display: 'block',
  marginBottom: theme.spacing(1),
  fontWeight: 'bold',
  color: theme.palette.text.secondary
}));

export const StyledDataGridPro = styled(DataGridPro)(({ theme }) => ({
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    flexGrow: 1,
    fontSize: '0.875rem',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    letterSpacing: '0.01em',
  }
}));


export const CustomScrollbarStyles = () => {
  const theme = useTheme();
  
  return (
    <GlobalStyles 
      styles={{
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '*::-webkit-scrollbar-track': {
          background: theme.palette.background.default,
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.secondary.light,
          borderRadius: '4px',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: theme.palette.secondary.main,
        },
        '*::-webkit-scrollbar-corner': {
          background: theme.palette.background.default,
        },
        // Firefox support
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: `${theme.palette.secondary.light} ${theme.palette.background.default}`,
        },
      }}
    />
  );
};